import { render, staticRenderFns } from "./BrandHeader.vue?vue&type=template&id=3dbf3a5e&scoped=true"
import script from "./BrandHeader.vue?vue&type=script&lang=js"
export * from "./BrandHeader.vue?vue&type=script&lang=js"
import style0 from "./BrandHeader.vue?vue&type=style&index=0&id=3dbf3a5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbf3a5e",
  null
  
)

export default component.exports